/**
 * PartAAccountHolder - TASK-371 (extracted from FormAForm)
 * Part A: Account Holder Identification — name and address fields.
 */

import React from 'react';
import { InheritedBadge } from './InheritedBadge';
import type { FormAFormData } from './FormAForm';

type AccountHolderData = FormAFormData['account_holder'];

interface PartAAccountHolderProps {
  data: AccountHolderData;
  onChange: (field: string, value: any) => void;
  errors: Record<string, string>;
  isInherited: boolean;
}

import { fieldError } from '../../../utils/formHelpers';

/**
 * Build a single-line display string from the address record.
 */
const formatAddress = (address: Record<string, any> | null | undefined): string => {
  if (!address || typeof address !== 'object') return '';
  return [address.street, address.city, address.postal_code, address.country]
    .filter(Boolean)
    .join(', ');
};

export const PartAAccountHolder: React.FC<PartAAccountHolderProps> = ({
  data,
  onChange,
  errors,
  isInherited,
}) => (
  <div className="px-4 pb-4 space-y-4">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">
          Account Holder Name *
          {isInherited && <InheritedBadge />}
        </label>
        <input
          type="text"
          value={data.name || ''}
          onChange={(e) => onChange('name', e.target.value)}
          className={`w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${errors['account_holder.name'] ? 'border-red-300' : 'border-gray-200'}`}
          placeholder="Full legal name"
        />
        {fieldError(errors, 'account_holder.name')}
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">
          Address
          {isInherited && <InheritedBadge />}
        </label>
        <input
          type="text"
          value={formatAddress(data.address)}
          readOnly
          className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg bg-gray-50 text-gray-600"
          placeholder="Populated from KYC address"
        />
      </div>
    </div>
  </div>
);

export default PartAAccountHolder;
